module.exports = __webpack_public_path__ + "media/recipes/36-20bb65db.png";